<template lang="pug">
  //- TODO
  //- remove the following temporary stuff
  .temporary(v-if="!isAuthenticated")
    .alert.error
      p Sie sind nicht angemeldet. Momentan ist es nicht möglich als Gast fortzufahren.
  //- keep this
  .checkout-stepper(v-else)
    Spinner(v-if="saving" :size="16" :thickness="3")
    .alert.success(v-if="success")
      p Vielen Dank für Ihre Bestellung
    .alert.warning(v-else-if="!articlePivots.length")
      p Sie haben keine Artikel im Warenkorb
    template(v-else)
      Tabs(:steps="steps" :position="position")
      validation-observer(v-slot="{ invalid }" ref="form")
        form.content.py-4(v-if="step" @submit.prevent="submit")
          transition(name="slide-fade" mode="out-in")
            CartStep.step(
              v-if="step.key === 'cart'"
              :pagination="pagination"
              @change-page="refetch"
              @update-cart="refetch"
            )
            AccountStep.step(
              v-if="step.key === 'account'"
              :form="form.account"
            )
            ShippingStep.step(
              v-if="step.key === 'shipping'"
              :form="form.shipping"
            )
            PaymentStep.step(
              v-if="step.key === 'payment'"
              :form="form"
            )
        .pagination-container
          button.prev.button(v-if="position > 1" @click="prev")
            font-awesome-icon(icon="arrow-left")
            span.ml-2 {{ prevLabel }}
          .prev.placeholder(v-else)
          button.next.button(v-if="position < steps.length" :disabled="pagination.loading || position === 1 && invalid" @click="next")
            span.mr-2 {{ nextLabel }}
            font-awesome-icon(icon="arrow-right")
          button.purchase.button(v-else :disabled="invalid" @click="submit") Kostenpflichtig Bestellen
</template>

<script>
import uniqid from 'uniqid';
import { mapGetters, mapActions } from 'vuex';

import { get, cloneDeep } from '@/helpers';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(de);

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Tabs from '@/extensions/shop/components/CheckoutStepper/Tabs';
import CartStep from '@/extensions/shop/components/CheckoutStepper/Steps/CartStep';
import AccountStep from '@/extensions/shop/components/CheckoutStepper/Steps/AccountStep';
import ShippingStep from '@/extensions/shop/components/CheckoutStepper/Steps/ShippingStep';
import PaymentStep from '@/extensions/shop/components/CheckoutStepper/Steps/PaymentStep';

export default {
    name: 'CheckoutStepper',
    data: () => ({
        success: false,
        steps: [
            {
                key: 'cart',
                position: 1,
                label: 'Warenkorb',
                icon: 'shopping-cart'
            },
            {
                key: 'account',
                position: 2,
                label: 'Benutzerdaten',
                icon: 'user'
            },
            {
                key: 'shipping',
                position: 3,
                label: 'Versand',
                icon: 'dolly-flatbed'
            },
            {
                key: 'payment',
                position: 4,
                label: 'Bestellen',
                icon: 'money-bill'
            }
        ],
        position: 1,
        initialised: false,
        wait: false, // prevent submitting while transition animation leads to valid
        saving: false,
        pagination: {
            loading: false,
            pageInfo: {
                currentPage: 1,
                lastPage: 1,
                perPage: 6,
                total: 0
            },
            items: []
        },
        form: {
            cart: {
                // needed for guest purchaser
                articlePivots: [],
                qty: 0,
                sum: 0,
                tax: 0
            },
            account: {
                // will get a purchaser
                id: undefined, // member id: undefined -> guest
                gender: 'M',
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                billing_address: {
                    // default_billing address data from member
                    id: undefined,
                    gender: 'M',
                    first_name: '',
                    last_name: '',
                    company: '',
                    street: '',
                    street_addition: '',
                    zipcode: '',
                    city: '',
                    country: '', // ISO-2 code
                    type: 'billing',
                    latitude: undefined,
                    longitude: undefined
                }
            },
            shipping: {
                id: undefined,
                gender: 'M',
                first_name: '',
                last_name: '',
                company: '',
                street: '',
                street_addition: '',
                zipcode: '',
                city: '',
                country: '', // ISO-2 code
                type: 'billing',
                latitude: undefined,
                longitude: undefined
            },
            payment: {
                id: undefined // payment method
            }
        }
    }),
    components: {
        Tabs,
        CartStep,
        AccountStep,
        ShippingStep,
        PaymentStep,
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        valid() {
            let valid = true;
            if (this.pagination.loading) valid = false;
            return valid;
        },
        step() {
            let step;
            if (this.position > 0) {
                step = this.steps.find(el => el.position === this.position);
            }
            return step;
        },
        prevLabel() {
            let label;
            if (this.position > 1) {
                const step = this.steps.find(el => el.position === this.position - 1);
                label = step.label;
            }
            return label;
        },
        nextLabel() {
            let label;
            if (this.position < this.steps.length) {
                const step = this.steps.find(el => el.position === this.position + 1);
                label = step.label;
            }
            return label;
        },
        articlePivots() {
            return get(this.cart, 'articlePivots', []);
        },
        ...mapGetters({
            cms: 'CMS',
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            customer: 'shop/customer',
            cart: 'shop/cart',
            token: 'auth/token',
            defaultTax: 'shop/defaultTax',
            defaultCustomerGroup: 'shop/defaultCustomerGroup'
        })
    },
    methods: {
        async next() {
            const valid = await this.$refs.form.validate();
            if (valid) {
                this.wait = true;
                ++this.position;

                setTimeout(() => {
                    this.wait = false;
                }, 400);
            }
        },
        prev() {
            --this.position;
        },
        async submit() {
            if (this.wait) {
                const errorMessage = {
                    id: uniqid(),
                    // title: 'Lucky Look',
                    // text: 'Schneller als der eigene Schatten',
                    title: 'Sie sind zu schnell',
                    text: 'Versuchen Sie es nochmal.',
                    type: 'warning',
                    autoclose: 4000
                };
                this.addMessage(errorMessage);
            } else {
                const valid = await this.$refs.form.validate();
                console.log('submit', valid);

                if (!valid) {
                    const errorMessage = {
                        id: uniqid(),
                        title: 'Ungültige Bestellung',
                        text: 'Korrigieren Sie Ihre Angaben.',
                        type: 'warning',
                        autoclose: 4000
                    };
                    this.addMessage(errorMessage);
                } else {
                    if (this.cart.articlePivots && this.cart.articlePivots.length) {
                        this.saving = true;

                        let items = [];
                        this.cart.articlePivots.forEach(pivot => {
                            const item = {
                                qty: pivot.qty,
                                article: {
                                    id: pivot.article.id
                                },
                                propertyValues: pivot.propertyValues.map(pv => ({ id: pv.id }))
                            };
                            items.push(item);
                        });

                        const data = {
                            shop: {
                                id: parseInt(this.cms.shop.id)
                            },
                            purchaser: {
                                customer: {
                                    id: parseInt(this.customer.id),
                                    member: {
                                        id: parseInt(this.member.id)
                                    }
                                }
                            },
                            items,
                            paymentMethod: {
                                id: this.form.payment.id
                            }
                        };
                        this.createPurchase(data)
                            .then(() => {
                                this.success = true;
                                this.addMessage({
                                    id: uniqid(),
                                    title: 'Erfolg',
                                    text: 'Ihre Bestellung wurde erfolgreich übermittelt.',
                                    type: 'success',
                                    autoclose: 4000
                                });
                            })
                            .finally(() => (this.saving = false));
                    }
                }
            }
        },
        refetch(currentPage = 1) {
            const shop = parseInt(this.cms.shop.id);
            const articleIDs = this.articlePivots.map(pivot => pivot.article.id);

            const payload = {
                pageInfo: {
                    currentPage,
                    perPage: this.pagination.pageInfo.perPage
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'articles',
                        in: articleIDs
                    }
                ]
            };

            if (articleIDs && articleIDs.length) {
                this.$set(this.pagination, 'loading', true);

                let actions = [];
                const fetchProducts = this.fetchProducts(payload).then(pagination => {
                    this.pagination = cloneDeep(pagination);

                    // const el = document.querySelector('.section.checkout')
                    // const container = document.querySelector('.checkout-page-columns > .column.left > .ps')
                    // if (container) {
                    //   if (! el) container.scrollTop = 0
                    //   else el.scrollIntoView()
                    // }

                    // this.products = products
                });
                actions.push(fetchProducts);

                // init cart only once
                if (!this.initialised) {
                    const initCart = this.initCart(this.member);
                    actions.push(initCart);
                }

                return Promise.all(actions).finally(() => {
                    this.$set(this.pagination, 'loading', false);
                    this.initialised = true;
                });
            }
        },
        ...mapActions({
            addMessage: 'message/add',
            createPurchase: 'shop/createPurchase',
            fetchProducts: 'shop/fetchProductsWithArticlesPaginated',
            initCart: 'shop/initCart'
        })
    },
    mounted() {
        this.refetch();

        // init form
        if (this.isAuthenticated && this.member) {
            this.form.account.id = this.member.id;
            this.form.account.gender = this.member.gender;
            this.form.account.first_name = this.member.first_name;
            this.form.account.last_name = this.member.last_name;
            this.form.account.phone = this.member.phone;
            this.form.account.email = this.member.email;

            // find addresses
            let billingAddress, shippingAddress;
            const addresses = this.member.addresses || [];

            addresses.forEach(address => {
                if (address.default_billing && !billingAddress) billingAddress = address;
                if (address.default_shipping && !shippingAddress) shippingAddress = address;
            });

            if (!billingAddress || !shippingAddress) {
                addresses.forEach(address => {
                    if (address.type === 'billing' && !billingAddress) billingAddress = address;
                    if (address.type === 'shipping' && !shippingAddress) shippingAddress = address;
                });
            }

            if (!billingAddress) billingAddress = addresses.find(address => address.type === 'main');
            if (!shippingAddress) shippingAddress = addresses.find(address => address.type === 'main');

            if (billingAddress) {
                let country;
                if (billingAddress.country) {
                    const label = countries.getName(billingAddress.country, 'de');
                    if (label) country = { code: billingAddress.country, label };
                }

                this.form.account.billing_address = {
                    id: billingAddress.id,
                    gender: billingAddress.gender,
                    first_name: billingAddress.first_name,
                    last_name: billingAddress.last_name,
                    company: billingAddress.company,
                    street: billingAddress.street,
                    street_addition: billingAddress.street_addition,
                    zipcode: billingAddress.zipcode,
                    city: billingAddress.city,
                    country, // object { code, label } -> must be converted to iso-2 (code only) before submit
                    type: 'billing',
                    latitude: billingAddress.latitude,
                    longitude: billingAddress.longitude
                };
            }

            if (shippingAddress) {
                let country;
                if (shippingAddress.country) {
                    const label = countries.getName(shippingAddress.country, 'de');
                    if (label) country = { code: shippingAddress.country, label };
                }

                this.form.shipping = {
                    id: shippingAddress.id,
                    gender: shippingAddress.gender,
                    first_name: shippingAddress.first_name,
                    last_name: shippingAddress.last_name,
                    company: shippingAddress.company,
                    street: shippingAddress.street,
                    street_addition: shippingAddress.street_addition,
                    zipcode: shippingAddress.zipcode,
                    city: shippingAddress.city,
                    country, // object { code, label } -> must be converted to iso-2 (code only) before submit
                    type: 'shipping',
                    latitude: shippingAddress.latitude,
                    longitude: shippingAddress.longitude
                };
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.pagination-container
  @apply flex justify-between
.content
  @apply flex justify-center items-center
  position: relative
  min-height: 280px
  .cart-step
    width: 100%
.spinner-container
  background: rgba(255, 255, 255, .5)
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%

.checkout-stepper
  @apply relative
  &::v-deep
    .panel
      @apply bg-gray-100
      width: 100%
      @screen md
        @apply mx-auto
        width: 580px
        max-width: 100%
      .double-field,
      .trible-field
        @screen sm
          @apply flex
          --gap: 1rem
          margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap))
          width: calc(100% + var(--gap))
          .field
            flex-basis: 50%
            flex-grow: 1
            margin: var(--gap) 0 0 var(--gap)
        .field fieldset.form-field
          margin-bottom: 1rem
        &:last-child
          .field
            &:last-of-type
              fieldset
                margin-bottom: 0
            fieldset
              @screen sm
                margin-bottom: 0
      .box .form-field:last-child
        margin-bottom: 0

      .preview
        @apply grid
        grid-gap: 1rem
        @screen md
          grid-template-rows: auto
          grid-template-columns: max-content auto
        &.member
          @apply mb-4
        &:hover,
        &:focus
          .icon
            .default-icon
              display: none
            .edit-icon
              display: block
        .icon
          @apply flex items-center
          min-height: 3rem
          svg
            width: 3rem
            height: 3rem
          .edit-icon
            display: none
            height: 2.8rem
        .data
          @apply flex flex-col justify-center
        .label
          @apply font-bold


      .field-preview + .field-preview
        @apply mt-3

  .spinner-container
    z-index: 1
</style>
